import { render, staticRenderFns } from "./DocumentUploadTab.vue?vue&type=template&id=bcca9238&scoped=true&"
import script from "./DocumentUploadTab.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadTab.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadTab.vue?vue&type=style&index=0&id=bcca9238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcca9238",
  null
  
)

export default component.exports